import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0B1537', // Your specified dark blue
            light: '#1C2855', // Lighter shade
            dark: '#060C24', // Darker shade
        },
        secondary: {
            main: '#2E5CFF', // Complementary blue
            light: '#5479FF',
            dark: '#1E3ECC',
        },
        background: {
            default: '#F7F8FA',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#0B1537', // Matching primary color
            secondary: '#4C5563',
        },
        grey: {
            50: '#F7F8FA',
            100: '#F0F2F7',
            200: '#E4E7EE',
            300: '#CFD4DD',
            400: '#9BA2B0',
            500: '#6B7280',
            600: '#4C5563',
            700: '#384152',
            800: '#1E2430',
            900: '#111827',
        },
        status: {
            success: '#10B981', // Green
            warning: '#F59E0B', // Amber
            error: '#EF4444', // Red
            info: '#2E5CFF', // Blue
        },
        neutral: {
            background: '#f0f0f0',
            darker: '#e0e0e0',
            hover: '#eaeaea',
            white: '#ffffff',
        },
        black: {
            0: '#000000',
        },
        red: {
            0: '#EF4444', // You can use your status.error color or choose another red
            main: '#EF4444',
            light: '#F87171',
            dark: '#DC2626',
        },
    },
    typography: {
        fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
        fontSize: {
            xs: '0.75rem', // 12px
            sm: '0.875rem', // 14px
            base: '1rem', // 16px
            lg: '1.125rem', // 18px
            xl: '1.25rem', // 20px
        },
        fontWeights: {
            light: 300,
            regular: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
        },
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 500,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 500,
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 500,
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 500,
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.5,
        },
        body2: {
            fontSize: '0.875rem',
            lineHeight: 1.5,
        },
        button: {
            textTransform: 'none', // Prevents automatic uppercase transformation
        },
        breadcrumb: {
            fontSize: '0.875rem',
        },
    },
    // Custom font sizes (available as theme.customFontSizes)
    // customFontSizes: {
    //     xs: '0.75rem', // 12px
    //     sm: '0.875rem', // 14px
    //     base: '1rem', // 16px
    //     lg: '1.125rem', // 18px
    //     xl: '1.25rem', // 20px
    // },
    shape: {
        borderRadius: 4,
    },

    raisedHover: {
        boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
        transform: 'translateY(-5px)',
        transition: 'box-shadow 0.3s, transform 0.3s',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                    textTransform: 'none',
                    fontWeight: 500,
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 12,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '16px 24px',
                    borderBottom: '1px solid',
                    borderColor: '#F0F2F7', // grey[100]
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: 24,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: 24,
                    paddingTop: 16,
                    borderTop: '1px solid',
                    borderColor: '#F0F2F7', // grey[100]
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0, // Extra small devices (phones, <600px)
            sm: 600, // Small devices (tablets, ≥600px)
            md: 900, // Medium devices (small laptops, ≥900px)
            lg: 1200, // Large devices (desktops, ≥1200px)
            xl: 1536, // Extra large devices (large screens, ≥1536px)
        },
    },
});

export default theme;
